import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPopoverModule, NgbProgressbarModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter, CustomDatepickerFormatter } from '../../pages/common/customDatepickerFormatter';
import { NumericOnlyDirective } from '../shared/directives/numeric-only.directive';
import { TableSortDirective } from './directives/table-sort.directive';
import { NumericOnlyAllowNegativeDirective } from './directives/numeric-only-allow-negative.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomLoginComponent } from './components/custom-login/custom-login.component';
import { CustomChatComponent } from './components/custom-chat/custom-chat.component';
import { NoUnsafeSpecialDirective } from './directives/no-unsafe-special.directive';

@NgModule({
  declarations: [
    NumericOnlyDirective,
    TableSortDirective,
    NumericOnlyAllowNegativeDirective,
    NoUnsafeSpecialDirective,
    CustomLoginComponent,
    CustomChatComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NumericOnlyDirective,
    TableSortDirective,
    NumericOnlyAllowNegativeDirective,
    NoUnsafeSpecialDirective,
    CustomLoginComponent,
    CustomChatComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbProgressbarModule,
    NgbPopoverModule,
    NgbPaginationModule,
    NgbModule,
    NgSelectModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter }, // gets datepicker formatted date
    { provide: NgbDateParserFormatter, useClass: CustomDatepickerFormatter }, // sets datepicker formatted date output    
  ],
})
export class CustomSharedModule { }
